import Vue from "vue";
import Router from "vue-router";
// import VueGtm from "vue-gtm";

import Home from "./views/Home.vue";
import DefaultTemplate from "./templates/Default.vue";

Vue.use(Router);

const vueRouter = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
      meta: {
        template: DefaultTemplate,
        protected: true
      }
    },
    {
      path: "/seja-forte",
      name: "workout",
      component: () => import("./views/Workout.vue"),
      meta: {
        template: DefaultTemplate,
        protected: true
      }
    },
    {
      path: "/seja-forte/meet",
      name: "workout-meet",
      component: () => import("./views/WorkoutMeet.vue"),
      meta: {
        template: DefaultTemplate,
        protected: true
      }
    },
    {
      path: "/seja-forte/historico",
      name: "workout-history",
      component: () => import("./views/WorkoutHistory.vue"),
      meta: {
        template: DefaultTemplate,
        protected: true
      }
    },
    {
      path: "/seja-forte/:id",
      name: "workout-exercise",
      component: () => import("./views/WorkoutExercise.vue"),
      meta: {
        template: DefaultTemplate,
        protected: true
      }
    },
    {
      path: "/seja-forte/gravado/:id",
      name: "workout-recorded",
      component: () => import("./views/WorkoutRecorded.vue"),
      meta: {
        template: DefaultTemplate,
        protected: true
      }
    },

    {
      path: "/aulas",
      name: "search",
      component: () => import("./views/Search.vue"),
      meta: {
        template: DefaultTemplate,
        protected: true
      }
    },
    {
      path: "/cadernos-de-ativacao",
      name: "feed",
      component: () => import("./views/Feed.vue"),
      meta: {
        template: DefaultTemplate,
        protected: true
      }
    },
    {
      path: "/organizador-do-caos",
      name: "chaos-organizer",
      component: () => import("./views/ChaosOrganizer.vue"),
      meta: {
        template: DefaultTemplate,
        protected: true
      }
    },
    {
      path: "/guru-do-amor",
      name: "love-guru",
      component: () => import("./views/LoveGuru.vue"),
      meta: {
        template: DefaultTemplate,
        protected: true
      }
    },
    {
      path: "/audios",
      name: "audios",
      component: () => import("./views/Audios.vue"),
      meta: {
        template: DefaultTemplate,
        protected: true
      }
    },
    {
      path: "/audios/:id",
      name: "audio",
      component: () => import("./views/Audio.vue"),
      meta: {
        template: DefaultTemplate,
        protected: true
      }
    },
    {
      path: "/podcasts",
      name: "podcasts",
      component: () => import("./views/Podcasts.vue"),
      meta: {
        template: DefaultTemplate,
        protected: true
      }
    },
    {
      path: "/podcasts/:id",
      name: "podcast-episodes",
      component: () => import("./views/PodcastEpisodes.vue"),
      meta: {
        template: DefaultTemplate,
        protected: true
      }
    },
    {
      path: "/ferramentas",
      name: "tools",
      component: () => import("./views/Tools.vue"),
      meta: {
        template: DefaultTemplate,
        protected: true
      }
    },
    {
      path: "/lives",
      name: "lives",
      component: () => import("./views/Lives.vue"),
      meta: {
        template: DefaultTemplate,
        protected: true
      }
    },
    {
      path: "/lives/:id",
      name: "live",
      component: () => import("./views/Live.vue"),
      meta: {
        template: DefaultTemplate,
        protected: true
      }
    },
    {
      path: "/aula/:id",
      name: "lesson",
      component: () => import("./views/Lesson.vue"),
      meta: {
        template: DefaultTemplate,
        protected: true
      }
    },
    {
      path: "/curso/:id",
      name: "short-course",
      component: () => import("./views/ShortCourse.vue"),
      meta: {
        template: DefaultTemplate,
        protected: true
      }
    },
    {
      path: "/trilha/:id/:slug",
      name: "trail",
      component: () => import("./views/Trail.vue"),
      meta: {
        template: DefaultTemplate,
        protected: true
      }
    },
    {
      path: "/trilha/:trail/aula/:id",
      name: "trail-lesson",
      component: () => import("./views/TrailLesson.vue"),
      meta: {
        template: DefaultTemplate,
        protected: true
      }
    },
    {
      path: "/trilha/:trail/episodio/:id",
      name: "trail-episode",
      component: () => import("./views/TrailEpisode.vue"),
      meta: {
        template: DefaultTemplate,
        protected: true
      }
    },
    {
      path: "/comunidade",
      name: "community",
      component: () => import("./views/Community.vue"),
      meta: {
        template: DefaultTemplate,
        protected: true
      }
    },
    {
      path: "/comunidade/topico/:id",
      name: "community-topic",
      component: () => import("./views/CommunityTopic.vue"),
      meta: {
        template: DefaultTemplate,
        protected: true
      }
    },
    {
      path: "/minha-conta",
      name: "account",
      component: () => import("./views/Account.vue"),
      meta: {
        template: DefaultTemplate,
        protected: true
      }
    },
    {
      path: "/minha-conta/mudar-senha",
      name: "account-password",
      component: () => import("./views/AccountPassword.vue"),
      meta: {
        template: DefaultTemplate,
        protected: true
      }
    },
    {
      path: "/gwsocial",
      name: "gwsocial",
      component: () => import("./views/GWSocial.vue"),
      meta: {
        template: DefaultTemplate,
        protected: true
      }
    },
    {
      path: "/register/:token",
      name: "register",
      component: () => import("./views/Register.vue"),
      meta: {
        template: () => import("./templates/Auth.vue"),
        protected: false
      }
    },
    {
      path: "/login",
      name: "login",
      component: () => import("./views/Login.vue"),
      meta: {
        template: () => import("./templates/Auth.vue"),
        protected: false
      }
    },
    {
      path: "/reset-password",
      name: "reset-password",
      component: () => import("./views/ResetPassword.vue"),
      meta: {
        template: () => import("./templates/Auth.vue"),
        protected: false
      }
    },
    {
      path: "/termos-de-uso",
      name: "terms",
      component: () => import("./views/Terms.vue"),
      meta: {
        template: () => import("./templates/Blank.vue"),
        protected: false
      }
    },
    {
      path: "/politica-de-privacidade",
      name: "privacy",
      component: () => import("./views/Privacy.vue"),
      meta: {
        template: () => import("./templates/Blank.vue"),
        protected: false
      }
    },
    {
      path: "*",
      name: "not-found",
      component: () => import("./views/NotFound.vue"),
      meta: {
        template: () => import("./templates/Blank.vue"),
        protected: false
      }
    }
  ]
});

// Vue.use(VueGtm, {
//   id: "GTM-TB4VDDF",
//   vueRouter
// });

export default vueRouter;
